import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Instagram, Linkedin } from 'lucide-react';

const ZALMA_URL = process.env.REACT_APP_ZALMA_URL || 'https://www.zalma.com.au';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-slate-400 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-8 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <Zap className="h-7 w-7 text-blue-500" />
              <span className="text-lg font-bold text-white" style={{ fontFamily: 'Manrope' }}>Zap AI</span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed max-w-sm">
              AI-powered automation for pet grooming salons. <a href={ZALMA_URL} className="hover:text-white">Zalma</a> is our flagship product.
            </p>
          </div>
          <div className="md:text-right">
            <h4 className="text-sm font-semibold text-white mb-4">Products</h4>
            <div className="space-y-2.5">
              <a href={ZALMA_URL} className="block text-sm hover:text-white">Zalma</a>
            </div>
          </div>
          <div className="md:text-right">
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <div className="space-y-2.5">
              <Link to="/about" className="block text-sm hover:text-white">About</Link>
              <Link to="/contact" className="block text-sm hover:text-white">Contact</Link>
            </div>
          </div>
          <div className="md:text-right">
            <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
            <div className="space-y-2.5">
              <Link to="/faq" className="block text-sm hover:text-white">FAQ</Link>
              <Link to="/privacy" className="block text-sm hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="block text-sm hover:text-white">Terms of Service</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <a href="#" aria-label="X" className="text-slate-500 hover:text-white transition-colors">
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="#" aria-label="Instagram" className="text-slate-500 hover:text-white transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="#" aria-label="LinkedIn" className="text-slate-500 hover:text-white transition-colors">
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
          <p className="text-xs text-slate-500">All rights reserved &copy; 2026 Zap AI</p>
        </div>
      </div>
    </footer>
  );
}
